<template>
  <el-form ref="form" :rules="formRules" :model="inputOrder" label-width="20%" class="input-order">
    <el-form-item label="家庭角色" prop="role">
      <el-select v-model="inputOrder.role">
        <el-option v-for="m in memberList" :key="m.roleIndex" :value="m.roleIndex" :label="m.role" />
      </el-select>
    </el-form-item>
    <el-form-item label="保额" prop="amount">
      <el-input v-model.number="inputOrder.amount">
        <template slot="append">元</template>
      </el-input>
    </el-form-item>
    <el-form-item label="保额递减" prop="decrease">
      <el-switch v-model="inputOrder.decrease" />
    </el-form-item>
    <el-form-item label="保费" prop="fee">
      <el-input v-model.number="inputOrder.fee">
        <template slot="append">元</template>
      </el-input>
    </el-form-item>
    <el-form-item label="保障年限" prop="period">
      <el-input v-model.number="inputOrder.period" />
    </el-form-item>
    <el-form-item label="保障年龄" prop="to_age">
      <el-input v-model.number="inputOrder.to_age" />
    </el-form-item>
    <el-form-item label="缴费年限" prop="year">
      <el-input v-model.number="inputOrder.year" />
    </el-form-item>
    <el-form-item label="类型" prop="risk_mask">
      <el-select v-model="inputOrder.risk_mask" multiple >
        <el-option v-for="(name, key) in risk_mask" :value="key" :key="key">{{name}}</el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="起始年份" prop="begin_year">
      <el-input v-model.number="inputOrder.begin_year" />
    </el-form-item>
    <el-form-item label="保险公司" prop="company_id">
      <el-select v-model="inputOrder.company_id" clearable>
        <el-option v-for="comp in companyList" :key="comp.id" :label="comp.name" :value="comp.id" />
      </el-select>
    </el-form-item>
    <el-form-item label="保单号" prop="plan_number">
      <el-input v-model="inputOrder.plan_number" />
    </el-form-item>
    <el-form-item label="产品名称" prop="product_id">
      <el-select v-model="inputOrder.product_id" clearable >
        <el-option v-for="(product) in companyProductList" :value="product.id" :label="product.name" :key="product.id">{{product.name}}</el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="reset">撤销</el-button>
      <el-button type="success" @click="commit">提交</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
  import request from '../../api/request'
  import { ORDER_RISK_MASK } from "../../define"

  export default {
    name: 'UserInputOrder',
    props: {
      userId: {
        type: Number,
        default: 0
      },
      orderId: {
        type: Number,
        default: 0
      }
    },
    data: function () {
      return {
        inputOrder: {},
        companyList:[],
        productList: [],
        familyData: {},
        formRules: {
          role: [{ required: true, message: '角色必须选择' }],
          amount: [{ required: true, message: '保额必须填写' }, { type: 'number' }],
          fee: [{ required: true, message: '保费必须填写'}, { type: 'number' }],
          period: [{ required: true, message: '保障年限必须填写 默认-1'}, { type: 'number' }],
          to_age: [{ required: true, message: '保障年龄必须填写 默认-1'}, { type: 'number' }],
          risk_mask: [{ required: true, message: '保障类型必须选择' }],
          begin_year: [{ required: true, message: '起始年份必须填写' }, { type: 'number' }],
          year: [{ required: true, message: '缴费年限必须填写' }, { type: 'number' }],
        },
        risk_mask: ORDER_RISK_MASK
      }
    },
    computed: {
      memberList: function () {
        if (!this.familyData.backbone) {
          return []
        }
        return this.familyData.backbone.map((person, index) => {
          return {
            roleIndex: index,
            role: person.role,
            value: person.role,
          }
        })
      },
      companyProductList: function () {
        return this.productList.filter(p => p.company_id === this.inputOrder.company_id )
      }
    },
    created: async function () {
      request.front.post('product_get_company_list', {
        range: [0, 100]
      }).then(resp => {
        this.companyList = resp.data.list
      })
      request.front.post('product_get_list', {
        range: [0, 500]
      }).then(resp => {
        this.productList = resp.data.list
      })
      request.front.post('user_get_family_data', {
        uid: this.userId
      }).then(resp => {
        this.familyData = resp.data
      })
      if (this.orderId) {
        request.front.post('user_get_order_list', {
          uid: this.userId,
          filter: {
            type: 'b',
            id: this.orderId
          }
        }).then(resp => {
          if (resp.data.list.length === 1) {
            const data = resp.data.list[0]
            this.inputOrder = {
              id: data.id,
              role: data.role_index,
              amount: data.amount,
              decrease: data.decrease,
              fee: data.fee / 100,
              period: data.period,
              to_age: data.to_age,
              year: data.year,
              risk_mask: data.risk_mask,
              begin_year: data.begin_year,
              company_id: data.company_id,
              plan_number: data.plan_number,
              product_id: data.product_id
            }
          }
        })
      }
    },
    methods: {
      reset: function () {
        this.inputOrder = {}
        this.$refs['form'].resetFields()
      },
      commit: function () {
        this.$refs['form'].validate(valid => {
          if (valid) {
            let param = {
              id: this.inputOrder.id || 0,
              uid: this.userId,
              role_index: this.inputOrder.role,
              role: this.memberList[this.inputOrder.role]['role'],
              role_title: this.memberList[this.inputOrder.role]['role'],
              amount: this.inputOrder.amount,
              decrease: !!this.inputOrder.decrease,
              fee: this.inputOrder.fee * 100,
              period: this.inputOrder.period,
              to_age: this.inputOrder.to_age,
              year: this.inputOrder.year,
              risk_mask: this.inputOrder.risk_mask,
              begin_year: this.inputOrder.begin_year
            }
            if (this.inputOrder['company_id']) {
              param.company_id = this.inputOrder.company_id
              param.company_str = this.companyList.find( c => c.id === this.inputOrder.company_id)['name']
            }
            if (this.inputOrder['plan_number']) {
              param.plan_number = this.inputOrder.plan_number
            }
            if (this.inputOrder['product_id']) {
              param.product_id   = this.inputOrder.product_id
              param.product_name = this.productList.find(p => p.id === this.inputOrder.product_id)['name']
            }
            request.front.post('user_add_plan_order', param).then(resp => {
              if (resp.data > 0) {
                this.$message.success('保存成功')
                this.inputOrder = {}
                this.$emit('input', false)
              } else {
                this.$message.error('保存失败')
              }
            })

          } else {
            this.$message.warning('请正确填写')
            return false
          }
        })
      }
    }
  }
</script>
<style>
  .input-order {
    text-align: left;
  }
</style>